 <svg
        class="animated-svg"
        [attr.viewBox]="'0 0 ' + 400 + ' ' + (height() + 120)"
        preserveAspectRatio="xMidYMin meet">
        
        <g wall-type-7 [height]="height()"></g>
        
        <g roof-type-2/>
        <g outline />
        <g window-type-1 [height]="height()" [finalHeight]="finalHeight()"/>

    </svg>